import { useSecaoDadosObra } from "./use-secao-dados-obra";
import { SecaoDadosObraView } from "./view-secao-dados-obra";
import type { SecaoDadosObraProps } from "./types-secao-dados-obra";

export function SecaoDadosObra(props: SecaoDadosObraProps) {
  const vm = useSecaoDadosObra(props);

  return <SecaoDadosObraView {...props} {...vm} />;
}

export type * from "./types-secao-dados-obra";
